import React, { useEffect, useRef } from 'react';

const ChannelSelectFilterInput = (props) => {
  const { filterText, onChange, isSelectorOpen } = props;
  const inputRef = useRef();
  useEffect(() => {
    if (isSelectorOpen) {
      inputRef.current.focus();
    }
  }, [isSelectorOpen]);
  return (
    <div className="ChannelSelector__search">
      <i className="far fa-search"></i>
      <input
        ref={inputRef}
        aria-label="Filter channels"
        type="text"
        autoFocus={true}
        value={filterText}
        onChange={(event) => onChange(event.target.value)}
        placeholder="Search for a channel"
      />
    </div>
  );
};

export default ChannelSelectFilterInput;
